import * as React from "react";
import { FileAbstractValidation } from "../../Validations/FileAbstractValidation";

interface IFileErrorMessage {
  label: string;
  validation: FileAbstractValidation;
}

export const FileErrorMessage = (props: IFileErrorMessage) => {
  return <div className="file-row__error-message">{props.validation.fileErrorMessage(props.label)}</div>;
};
